import { Component, ElementRef, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import axios from 'axios';
import { Authenticationservice } from '../../services/authentication.service';
import { BrdsqlService } from '../../services/brdsql.service';

@Component({
  selector: 'app-list-kpi-zone',
  templateUrl: './list-kpi-zone.component.html',
  styleUrls: ['./list-kpi-zone.component.css']
})
export class ListKpiZoneComponent {
  userdata: any;
  constructor(private auth: Authenticationservice, private spinner: NgxSpinnerService, private brdsql: BrdsqlService) {
    this.userdata = this.auth.Authention();
  }

  ngOnInit(): void {
    let selecttime1 = this.selecttime1;
    console.log('selecttime1 B:', this.selecttime1);
    let dataZ = this.brdsql.sumZonne;
    let userD = this.userdata;

    if (userD.zonedata == 'PA') {
      this.selectsup = dataZ;
    }
    else if (userD.userlevel == 15) {
      this.selectsup = dataZ.filter((el) => el[0] == userD.zonedata)
    }
    else if (userD.userlevel == 14 || userD.userlevel == 1) {
      this.selectsup = dataZ.filter((el) => el[1] == userD.zonedata)
    }

    this.edit_st = 0;
    this.type_s = 1;
    //this.Loaddata1();
    //this.Loaddata3();
    //console.log('userD',userD);
    //console.log('selectsup',this.selectsup);
    const currentDate = new Date();

    const filteredSelectTime = selecttime1.filter(item => {
      const itemDate = new Date(item[1]);
      return itemDate <= currentDate;
    });
    this.selecttime1 = filteredSelectTime;
    //console.log('filteredSelectTime:', filteredSelectTime);

  }
  scrollTo(element: any): void {
    (document.getElementById(element) as HTMLElement).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }

  selecttime1 = [
    ['งวด ก.พ. 2567', '2024-02-01'],
    ['งวด มี.ค. 2567', '2024-03-01'],
    ['งวด เม.ย. 2567', '2024-04-01'],
    ['งวด พ.ค. 2567', '2024-05-01']
  ];
  selectsup = [];
  selectP = []; selectS = [];
  type_s: number;
  edit_st: number;

  dataSource = [];

  dataApi0 = []; dataApi3 = []; dataApi1 = [];
  Loaddata1() {
    let time = this.selectP
    this.spinner.show()
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s='${time[1]}'Lotd,*&f=CPS6263.dbo.[fnc_brdlotwork_6701_z]('${time[1]}')&w=1=1`;
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = res.data;
      if (data.length >= 1) {
        //this.selectsup = data.filter((el) => el.Supcode == 'sum').map(function (elem ){return [elem.Partcode, elem.Supzone, elem.Supcode, elem.SUPNAME]});
        data = data.map(item => {
          return { ...item, modify: false };
        });
        this.dataApi0 = (data)
        //this.dataApi1 = (data).filter((el) => el.Supzone == '01');
        if (this.selectS.length > 0) {
          this.filter_data();
        }
      }
      else { this.dataApi0 = []; this.filter_data(); }

    }).catch(err => { throw (err) })
  }

  sum_sv = [];
  filter_data() {
    let aj = this.selectS;
    let userD = this.userdata;
    if (this.dataApi0.length > 0) {
      if (aj[1] != "sum") {
        this.dataApi1 = this.dataApi0.filter((el) => el.Supzone == aj[1] && el.Supcode != aj[2]);
      }
      else {
        this.dataApi1 = this.dataApi0.filter((el) => el.Partcode == aj[0] && el.Supcode != aj[2]);
      }
      this.sum_sv = this.dataApi1.map(function (el) { return el.Supzone });
      console.log('sum_sv:', this.sum_sv);

      this.dataSource = this.dataApi1
      console.log('list_sup', this.dataApi1, '/zonedata ', userD.zonedata)
    }
    else { this.dataApi1 = [] }
  }


  //`https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_t_s_w?t=[dbo].[brdlotwork]&s=[knowledge]='`+value+`' &w=Lotdate = '`+Lot+`' and supcode='`+supcode+`'`
  saveDataKpi() {
    let time = this.selectP, value = this.dataApi1.filter((el) => el.modify == true);
    let x = 0, y = 0;
    if (value.length > 0) {
      let supdata = value.map(function (elem) { return elem.Supzone });
      if (confirm('ต้องการบันทึกข้อมูล ' + supdata + ' | จำนวน ' + value.length + ' รายการ หรือไม่?')) {
        for (let i = 0; i < value.length; i++) {
          let url: string, ar0 = value[i]
          url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_t_s_w?t=[dbo].[brdlotwork]&s=
             [sTarget01]=${ar0.sTarget01},[Target1]=${ar0.Target1}
            ,[sTarget02]=${ar0.sTarget02},[Target2]=${ar0.Target2},[Success2]=${ar0.Success2}
            ,[sTarget03]=${ar0.sTarget03},[Target3]=${ar0.Target3},[Success3]=${ar0.Success3}
            ,[sTarget04]=${ar0.sTarget04},[Target4]=${ar0.Target4}
            ,[sTarget05]=${ar0.sTarget05},[Target5]=${ar0.Target5}
            ,[sTarget06]=${ar0.sTarget06},[Target6]=${ar0.Target6}
            ,[sTarget07]=${ar0.sTarget07},[Target7]=${ar0.Target7}
            ,[sTarget08]=${ar0.sTarget08},[Target8]=${ar0.Target8},[Success8]=${ar0.Success8}
            ,[sTarget09]=${ar0.sTarget09},[Target9]=${ar0.Target9},[Success9]=${ar0.Success9}
            ,[sTarget10]=${ar0.sTarget10},[Target10]=${ar0.Target10},[Success10]=${ar0.Success10}
            ,[sTarget11]=${ar0.sTarget11},[Target11]=${ar0.Target11},[Success11]=${ar0.Success11}

            ,[sTarget12]=${ar0.sTarget12},[Target12]=${ar0.Target12},[Success12]=${ar0.Success12}
            ,[sTarget13]=${ar0.sTarget13},[Target13]=${ar0.Target13},[Success13]=${ar0.Success13}
            ,[sTarget14]=${ar0.sTarget14},[Target14]=${ar0.Target14},[Success14]=${ar0.Success14}
            ,[sTarget15]=${ar0.sTarget15},[Target15]=${ar0.Target15},[Success15]=${ar0.Success15}
            ,[sTarget16]=${ar0.sTarget16},[Target16]=${ar0.Target16},[Success16]=${ar0.Success16}
            ,[sTarget17]=${ar0.sTarget17},[Target17]=${ar0.Target17},[Success17]=${ar0.Success17}
            ,[sTarget18]=${ar0.sTarget18},[Target18]=${ar0.Target18},[Success18]=${ar0.Success18}
            ,[sTarget19]=${ar0.sTarget19},[Target19]=${ar0.Target19},[Success19]=${ar0.Success19}
            ,[sTarget20]=${ar0.sTarget20},[Target20]=${ar0.Target20},[Success20]=${ar0.Success20}
            ,[sTarget21]=${ar0.sTarget21},[Target21]=${ar0.Target21},[Success21]=${ar0.Success21}
            ,[sTarget22]=${ar0.sTarget22},[Target22]=${ar0.Target22},[Success22]=${ar0.Success22}
            ,[sTarget23]=${ar0.sTarget23},[Target23]=${ar0.Target23},[Success23]=${ar0.Success23}
            ,[sTarget24]=${ar0.sTarget24},[Target24]=${ar0.Target24},[Success24]=${ar0.Success24}
            ,[sTarget25]=${ar0.sTarget25},[Target25]=${ar0.Target25},[Success25]=${ar0.Success25}            

            ,[sTarget27]=${ar0.sTarget27},[Target27]=${ar0.Target27},[Success27]=${ar0.Success27}
            ,[sTarget28]=${ar0.sTarget28},[Target28]=${ar0.Target28},[Success28]=${ar0.Success28}
            ,[sTarget29]=${ar0.sTarget29},[Target29]=${ar0.Target29},[Success29]=${ar0.Success29}
            ,[sTarget30]=${ar0.sTarget30},[Target30]=${ar0.Target30},[Success30]=${ar0.Success30}

            ,[sTarget31]=${ar0.sTarget31},[Target31]=${ar0.Target31},[Success31]=${ar0.Success31}
            ,[sTarget32]=${ar0.sTarget32},[Target32]=${ar0.Target32},[Success32]=${ar0.Success32}
            ,[sTarget33]=${ar0.sTarget33},[Target33]=${ar0.Target33},[Success33]=${ar0.Success33}
            ,[sTarget34]=${ar0.sTarget34},[Target34]=${ar0.Target34},[Success34]=${ar0.Success34}
            ,[sTarget35]=${ar0.sTarget35},[Target35]=${ar0.Target35},[Success35]=${ar0.Success35}

            ,[sTarget36]=${ar0.sTarget36},[Target36]=${ar0.Target36},[Success36]=${ar0.Success36}
            ,[sTarget37]=${ar0.sTarget37},[Target37]=${ar0.Target37},[Success37]=${ar0.Success37}

            ,[DateEdit]=getdate()&w=[dataid]=${ar0.dataid}`;

          axios.post(url).then(res => {
            let data = res.data;
            if (data.rowsAffected[0] == 1) y++
            else x++
          }).catch(err => { console.log(err) })
          //console.log('url', i, ';', url)
        }
        //alert("สำเร็จ:"+y+" ไม่สำเร็จ:"+x);
        //console.log('สำเร็จ',y,'ไม่สำเร็จ',x)
        this.edit_st = 0
        setTimeout(() => {
          this.Loaddata1();
        }, 300);
      }
    }
    else alert('ยังไม่มีการแก้ไข')
  }

  printPage() {
    window.print();
  }

  THtoLocalstring(date: string) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }
}
